import manipulation from "../../translations/pl_PL/blog/manipulation.json";
import { PUT_DATA_BLOG } from '../Blog/action';

function knowladgeManipulationReducer(state = manipulation, action) {
  switch (action.type) {
    case PUT_DATA_BLOG:
      {
        if (action.meta === "manipulation") {
          return action.payload;
        } else { 
          return state }
      }

    default:
      return state;
  }
}

export default knowladgeManipulationReducer;
